import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { getUsers,deleteUser,resourcesUnits,activeRoutes } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert} from '../../../helpers/alerts/alertHelper';
import { getPolicyUser } from '../../../helpers/api_helper';
import {Container} from "reactstrap";
import { getStorageCompany,getStorageUser } from '../../../helpers/api_helper';
import FilesListHelper from '../../../helpers/FilesListHelper';
import ButtonHelper from '../../../helpers/ButtonHelper';

const Units = () => {
    const [modalFile, setModalFile] = useState({show:false,id:null,files:[]});
    const policy = getPolicyUser();
    const authUser = getStorageUser();
    const company = getStorageCompany();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false});
    const [dataPag, setDataPag] = useState({total:0});
    const [filters,setFilters] = useState({page:1,perPage:15,search:'',orderBy:'id',order:'asc',companySession:company.id});
    const [items, setItems] = useState([]);
    const [itemBase, setItemBase] = useState({
        id: null,
        number:null,
        type:'',
        vin:'',
        no_motor:'',
        automatic:0,
        plates:'',
        model:null,
        brand:'',
        counter:0,
        mechanic_meg:'',
        concessionary:null,
        concessionary_id:authUser.profile_id!=4 ? null:authUser.id,
        company_id:company.id,
        name:'',
        email:'',
        profile_id:4,
        phone:null,
        localPhone:null,
        concessionaryNew: false,
        route_id:authUser.route_id,
        route:authUser.route,
        fuel_type:null,
        concessionaryNewName: ''
    });

    const [item, setItem] = useState(itemBase);
    const dispatch = useDispatch()
    useEffect(() => {
        const getUnits = async() =>{
            let params={params:filters}
            setPending(true)
            const response = await resourcesUnits('get',params);
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)    
        }
        getUnits();
    }, [filters])

    const addUpd = (row=false) => {
        setItem(row.id ? row:itemBase)
        setModal({...modal,show:true, update: (row.id ? true:false)})
    }

    const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            resourcesUnits('del',id,id).then(response => {
                Alert(response.message,response.status)
                if (response.status) {
                    setItems(
                        items.filter(i => i.id != id)
                    );
                }           
            })
        });
    }

    const columns = Columns(addUpd,destroy,setModalFile, authUser);
	document.title = "Unidades | Sistema de logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Unidades" filterInp={false} columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                            <div className="mb-3">
                                <ButtonHelper 
                                    addButon={true}
                                    actionAddButon={addUpd}
                                />
                            </div>
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        item={item}
                        setItem={setItem}
                    />
                }
                {modalFile.show &&
                    <FilesListHelper
                        modal={modalFile}
                        setModal={setModalFile}
                        title='Archivos de Unidad'
                        type='unit'
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Units;